import { render } from "./AgentDetails.vue?vue&type=template&id=9673dfc6"
import script from "./AgentDetails.vue?vue&type=script&lang=js"
export * from "./AgentDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__